<template>
  <MetricTile
    :loading="loading"
    :no-data="!metric || !metric.completed"
    icon="fa-solid fa-user-plus"
    :show-duration="false"
    color="teal"
  >
    <template #title>Value Scales Complete</template>
    <template #metric>
      {{ metric.completed }}
    </template>
  </MetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
const { metric, loading } = useMetricTile<
  {
    completed: number;
    total: number;
    ratio: number;
  }>("users-completed-value-scales-ratio");
</script>
